export enum CouponError {
  EntityNotFound = 'EntityNotFound',
  CannotBeAppliedCoupon = 'CannotBeAppliedCoupon',
  CouponIsDisabled = 'CouponIsDisabled',
  ExpiryCoupon = 'ExpiryCoupon'
}
